"use strict";

/**
 * Assigns locale to date result
 */
const getLocaleDates = (result, props) => {
  const { startDate, endDate } = result;
  const { locale } = props;

  return {
    startDate: startDate.setLocale(locale),
    endDate: endDate.setLocale(locale)
  };
};

module.exports = getLocaleDates;
